import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="legal-page">
      <div className="container legal-content">
        <h1>Privacy Policy</h1>

        <Link to="/" className="back-home">
          &larr; Torna alla home
        </Link>

        <p>
          Questa informativa descrive il trattamento dei dati personali raccolti
          tramite il sito <strong>luxastudio.it</strong>.
        </p>

        <h2>Titolare del trattamento</h2>
        <p>
          Luxa Studio
          <br />
          Email: <a href="mailto:info@luxastudio.it">info@luxastudio.it</a>
        </p>

        <h2>Tipologia di dati trattati</h2>
        <p>
          Dati identificativi e di contatto forniti volontariamente tramite form
          o email (es. nome, email, azienda, contenuto del messaggio).
        </p>

        <h2>Finalit&agrave; e base giuridica</h2>
        <p>
          I dati sono trattati per rispondere a richieste di contatto,
          preventivo, valutazione o collaborazione. La base giuridica &egrave;
          l&apos;esecuzione di misure precontrattuali richieste
          dall&apos;interessato (art. 6.1.b GDPR) e, ove necessario, il legittimo
          interesse del titolare (art. 6.1.f GDPR).
        </p>

        <h2>Conservazione</h2>
        <p>
          I dati sono conservati per il tempo necessario a gestire la richiesta
          e, successivamente, per i tempi previsti da obblighi legali o per la
          tutela dei diritti del titolare.
        </p>

        <h2>Comunicazione dei dati</h2>
        <p>
          I dati non sono diffusi. Possono essere trattati da fornitori tecnici
          strettamente necessari all&apos;erogazione dei servizi digitali
          (hosting/email), nominati ove richiesto dalla normativa.
        </p>

        <h2>Diritti dell&apos;interessato</h2>
        <p>
          Puoi richiedere accesso, rettifica, cancellazione, limitazione,
          opposizione e portabilit&agrave; dei dati, oltre a proporre reclamo al
          Garante Privacy. Per esercitare i tuoi diritti scrivi a{" "}
          <a href="mailto:info@luxastudio.it">info@luxastudio.it</a>.
        </p>

        <h2>Aggiornamenti</h2>
        <p>Ultimo aggiornamento: 27 aprile 2026.</p>
      </div>
    </div>
  );
}
